import { AlertTriangle } from 'lucide-react';
import { C, FONTS } from '../../tokens/design';

export default function PageError({ error, onRetry }) {
  const msg = typeof error === 'string' ? error : error?.message || 'Something went wrong';
  const meta = typeof error === 'object' && error
    ? [
        error.status ? `HTTP ${error.status}` : null,
        error.code || null,
        error.method && error.path ? `${error.method} ${error.path}` : null,
        error.requestId ? `Request ${error.requestId}` : null,
      ].filter(Boolean).join(' | ')
    : '';
  return (
    <div style={{
      padding: '12px 14px', borderRadius: 8, marginBottom: 12,
      background: `${C.red}08`, border: `1px solid ${C.red}33`,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.03)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 9, minWidth: 0 }}>
        <span style={{ display: 'inline-flex', color: C.red, flexShrink: 0 }}><AlertTriangle size={15} strokeWidth={1.8} /></span>
        <span style={{ fontSize: 11, color: C.red, fontFamily: FONTS.mono, lineHeight: 1.45 }}>
          {msg}
          {meta && <span style={{ display: 'block', marginTop: 3, color: C.t2 }}>{meta}</span>}
        </span>
      </div>
      {onRetry && (
        <button onClick={onRetry} style={{
          background: `${C.red}10`, border: `1px solid ${C.red}55`, color: C.red,
          cursor: 'pointer', fontSize: 10, fontFamily: FONTS.mono,
          padding: '5px 10px', borderRadius: 6, whiteSpace: 'nowrap',
        }}>Retry</button>
      )}
    </div>
  );
}
